export default {
  actions: {
    activateCadasterLayer: 'Visualizar capa catastral'
  },
  names: {
    image: 'Imagen',
    keywords: 'Búsquedas relacionadas',
    lateral: 'Lateral',
    map: 'Mapa',
    next: 'Seguiente',
    panorama: 'Panorama',
    pointCloud: 'Nube de puntos',
    previous: 'Anterior',
    projection: 'Proyección',
    tools: 'Herramientas',
    home: 'Inicio',
    baseMap: 'Mapa base'
  },
  messages: {
    referenceNotFound: 'No se ha encontrado la referencia'
  },
  tools: {
    auth: {
      loggedToMapia: 'La sessión de Mapia se ha iniciado correctamente'
    },
    downloads: {
      headerName: 'Descargas',
      title: 'Centro de descargas'
    },
    language: {
      headerName: 'Idioma'
    },
    opendata: {
      headerName: 'Open Data'
    },
    panorama: {
      addAmbit: 'Capa de ámbitos',
      addAmbitCaption: 'Añade una capa con los ámbitos en los que hay panoramas',
      addLayer: 'Capa panoramas',
      addLayerCaption: 'Añaden una capa con los puntos donde hay panormas',
      headerName: 'Entorno 3D',
      title: 'Fotografías panorámicas y nubes de puntos',
      help: 'Haz click sobre el mapa para acceder a la fotografía panorámica y las nubes de puntos obtenidas mediante Mobile Mapping.',
      centerMap: 'Centrar mapa',
      noDataError: 'No se han encontrado datos en esta localización.',
      disablePano: 'Desactiva panorama',
      enablePano: 'Activa panorama',
      enablePanoDescription: 'Activa/desactiva el visor de panoramas',
      enableLateral: 'Activa imagen lateral',
      disable3D: 'Desactiva 3D',
      enable3D: 'Activa 3D',
      enable3DDescription: 'Activa/desactiva el visor de núbes de puntos',
      unsync3D: 'Desincroniza 3D',
      sync3D: 'Sincroniza 3D',
      openPano: 'Abre panorama',
      openPanoCaption: 'Abre el panorama en otra ventana',
      openPointCloud: 'Abre nube de puntos',
      openPointCloudCaption: 'Abre la nube de puntos en otra ventana',
      rotateLeft: 'Gira el panorama 90º a la izquierdas',
      rotate180: 'Gira el panorama 180º',
      rotateRight: 'Gira el panorama 90º a la derecha',
      mustLogin: 'Inicia sesión para visualizar los panoramas',
      infoCampaign: 'Información campaña',
      descriptionCampaign: 'Descripción campaña',
      zoneCampaign: 'Zona',
      startCampaign: 'Inici campaña',
      endCampaign: 'Final campaña',
      splitVertially: 'Dividir verticalmente',
      splitHorizontaly: 'Dividir horizontalmente'
    },
    addCustomLayer: {
      headerName: 'Añadir capa',
      title: 'Añadir capa personalizada',
      layerFormat: 'Escoge formato nueva capa',
      layerFormatOptions: [
        'WMS',
        'TMS',
        'GeoJSON',
        'GML'
      ],
      layerName: 'Escribe el nombre de la capa',
      layerURL: 'Escribe la URL de la capa o servicio',
      properties: 'Propiedades',
      layerWMSLayers: 'Indica las capas del WMS: capa1, capa2, ...',
      layerWMSLayersHint: 'Utiliza la coma para separar cada capa.',
      layerProjection: 'Proyección:',
      layerWMSSingleImage: 'Cargar WMS sin teselar, utilizando una sola imagen',
      layerTMSInvert: 'Invertir las teselas en el eje de les Y',
      geojsonColor: 'Selecciona color línea',
      geojsonFillColor: 'Selecciona color relleno',
      geojsonWeight: 'Grosor',
      geojsonWeightHint: 'Solo números',
      addButton: 'Añadir capa al mapa'
    }
  }
}
